export default {"src":"/komodo/_next/static/media/carousel-right.fa264267.svg","height":42,"width":60,"blurWidth":0,"blurHeight":0};